import { render, staticRenderFns } from "./Scrolltop.vue?vue&type=template&id=1e60713c&scoped=true&"
import script from "./Scrolltop.vue?vue&type=script&lang=js&"
export * from "./Scrolltop.vue?vue&type=script&lang=js&"
import style0 from "./Scrolltop.vue?vue&type=style&index=0&id=1e60713c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e60713c",
  null
  
)

export default component.exports